import * as Preact from "preact"

import "@frog/source/views/components/UnitExperienceBar.less"

export default class UnitExperienceBar {
    render() {
        if(this.props.unit == undefined) return
        if(this.props.unit.maxexperience == undefined) return
        return (
            <div class="UnitExperienceBar" isVisible={this.props.isVisible ?? true}>
                <div class="Fill" style={{
                    "width": Math.max(0, this.props.unit.experience / this.props.unit.maxexperience) * 100 + "%",
                }}/>
            </div>
        )
    }
}
